import React from 'react';
import { motion } from 'framer-motion';
import { Download, BookOpen, Utensils } from 'lucide-react';
const steps = [{
  icon: Download,
  title: 'Descargás',
  desc: 'El PDF en tu celular o tablet ahora mismo.'
}, {
  icon: BookOpen,
  title: 'Elegís',
  desc: 'La receta de 15 minutos que más te tiente hoy.'
}, {
  icon: Utensils,
  title: 'Aplicás',
  desc: "El 'Rocío de Oro' y disfrutás de un sabor de bodegón sin limpiar grasa."
}];
export function HowItWorks() {
  return <section className="bg-charcoal-light py-24 px-6 md:px-12" data-id="element-80">
      <div className="max-w-5xl mx-auto" data-id="element-81">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-82">
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-cream mb-6" data-id="element-83">
            Cómo funciona
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-84">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-amber/20 z-0" data-id="element-85" />

          {steps.map((step, index) => {
          const Icon = step.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.6,
            delay: index * 0.2
          }} className="relative z-10 flex flex-col items-center text-center" data-id="element-86">
                <div className="w-24 h-24 rounded-full bg-charcoal border-4 border-amber flex items-center justify-center mb-6 shadow-xl shadow-amber/10" data-id="element-87">
                  <Icon className="text-amber w-10 h-10" data-id="element-88" />
                </div>
                <h3 className="font-serif font-bold text-2xl text-cream mb-4" data-id="element-89">
                  {index + 1}. {step.title}
                </h3>
                <p className="font-sans text-cream/70 leading-relaxed max-w-xs" data-id="element-90">
                  {step.desc}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}